<template>
  <page-list
    :list="list"
    :columns="columns"
    :singleActions="singleActions"
    :group-actions="groupActions"
    :exportDataOptions="exportDataOptions" />
</template>

<script>
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import { getCopyWithContentTableColumn, getStatusTableColumn, getTimeTableColumn, getTagTableColumn, getBillBrandTableColumn, getAccountTableColumn, getRegionTableColumn, getProjectTableColumn } from '@/utils/common/tableColumn'
import { getNameFilter, getTimeRangeFilter } from '@/utils/common/tableFilter'
import { getBillResourceTypeLabel } from '@Bill/utils'

const resoourceStatusModule = {
  instance: 'server',
  pod: 'pod',
}

export default {
  name: 'ResourceTagEventList',
  mixins: [WindowsMixin, ListMixin],
  props: {
    data: {
      type: Object,
      required: true,
    },
    params: {
      type: Object,
      required: true,
    },
    resourceTagColumns: Array,
  },
  data () {
    const { resource_type } = this.data
    return {
      list: this.$list.createList(this, {
        id: 'ResourceTagEventList',
        resource: 'meter_events',
        apiVersion: 'v1',
        getParams: this.getParams,
        noPreLoad: true,
        hiddenColumns: ['created_at'],
        filterOptions: {
          id: getNameFilter({ field: 'id', label: this.$t('bill.event_id') }),
          resource_name: getNameFilter({ field: 'resource_name', label: this.$t('bill.text_72') }),
          resource_id: getNameFilter({ field: 'resource_id', label: this.$t('bill.text_120') }),
          external_id: getNameFilter({ field: 'external_id', label: this.$t('bill.external_id') }),
          usage_start_time: getTimeRangeFilter({ field: 'usage_start_time', label: this.$t('bill.text_40') }),
          usage_end_time: getTimeRangeFilter({ field: 'usage_end_time', label: this.$t('bill.text_41') }),
        },
      }),
      columns: [
        {
          field: 'id',
          title: this.$t('bill.event_id'),
        },
        {
          field: 'resource_name',
          title: this.$t('bill.text_72') + '/ID',
          slots: {
            default: ({ row }, h) => {
              const ret = []
              ret.push(<list-body-cell-wrap copy field='resource_name' row={row} />)
              ret.push(<list-body-cell-wrap copy field='resource_id' row={row} hideField><span class="text-color-secondary">{row.resource_id}</span></list-body-cell-wrap>)
              return ret
            },
          },
        },
        {
          field: 'resource_type',
          title: this.$t('bill.text_73'),
          formatter: ({ row }) => {
            return getBillResourceTypeLabel(row.resource_type)
          },
        },
        getCopyWithContentTableColumn({
          field: 'external_id',
          title: this.$t('bill.external_id'),
        }),
        getStatusTableColumn({ statusModule: resoourceStatusModule[resource_type] || 'common' }),
        {
          field: 'usage_type',
          title: this.$t('bill.usage_type'),
          formatter: ({ row }) => {
            if (this.$te(`rate_usage_type.${row.usage_type}`)) {
              return this.$t(`rate_usage_type.${row.usage_type}`)
            }
            return row.usage_type || '-'
          },
        },
        {
          field: 'model',
          title: this.$t('bill.billing_spec'),
          formatter: ({ row }) => {
            return row.model || '-'
          },
        },
        {
          field: 'quantity',
          title: this.$t('bill.billing_quantity'),
        },
        {
          field: 'spec',
          title: this.$t('bill.text_121'),
          formatter: ({ row }) => {
            const { spec = '' } = row
            return JSON.stringify(spec)
          },
        },
        getTimeTableColumn({ field: 'usage_start_time', title: this.$t('bill.text_40') }),
        getTimeTableColumn({ field: 'usage_end_time', title: this.$t('bill.text_41') }),
        getTagTableColumn(),
        getBillBrandTableColumn(),
        getAccountTableColumn(),
        getRegionTableColumn(),
        getProjectTableColumn(),
      ],
      groupActions: [
        {
          label: this.$t('bill.rebuild_event'),
          action: () => {
            this.createDialog('ResourceTagRebuildEventDialog', {
              data: [this.data],
              columns: this.resourceTagColumns,
              onManager: this.onManager,
              refresh: this.refresh,
            })
          },
        },
      ],
    }
  },
  computed: {
    exportDataOptions () {
      return {
        downloadType: 'local',
        items: this.columns,
        title: this.$t('bill.event'),
      }
    },
  },
  created () {
    this.list.fetchData()
  },
  methods: {
    getParams () {
      return {
        details: true,
        admin: this.$store.getters.isAdminMode,
        resource_id: this.data.id,
      }
    },
    refresh () {
      this.list.refresh()
    },
  },
}
</script>
